import MegaETHHoldersTool from './components/MegaETHHoldersTool';

function App() {
  return (
    <div className="App">
      <MegaETHHoldersTool />
    </div>
  );
}

export default App;